import { rockApi, unwrapRockResponse } from "./rockApiClient";
import { normalizePaginate } from "../utils/normalizePaginate";

function ensureArray(data) {
  return Array.isArray(data) ? data : [];
}

export const rockLogsApi = {
  async getChart() {
    const resp = await rockApi.get("/rocks/logs/get-chart");
    const data = unwrapRockResponse(resp);
    return ensureArray(data);
  },

  async getBarChart() {
    const resp = await rockApi.get("/rocks/logs/get-bar-chart");
    const data = unwrapRockResponse(resp);
    return ensureArray(data);
  },

  /** Distinct app versions for the filter dropdown (no query params). */
  async getFilter() {
    const resp = await rockApi.get("/rocks/logs/get-filter");
    const data = unwrapRockResponse(resp);

    if (data && typeof data === "object" && !Array.isArray(data) && Array.isArray(data.app_versions)) {
      const options = [{ label: "App version", value: "" }];
      for (const v of data.app_versions) {
        if (v == null || String(v).length === 0) continue;
        options.push({ label: String(v), value: String(v) });
      }
      return options;
    }

    return ensureArray(data);
  },

  /**
   * Paginated log list via GET `/rocks/logs/get-filter` with list query params.
   * Filter options for `app_version` come from the same path without pagination params.
   */
  async getLogs({ page = 1, items_per_page = 10, q, app_version } = {}) {
    const params = { page, items_per_page };
    const trimmed = typeof q === "string" ? q.trim() : "";
    if (trimmed) params.q = trimmed;
    if (app_version !== undefined && app_version !== null && String(app_version).length > 0) {
      params.app_version = app_version;
    }
    const resp = await rockApi.get("/rocks/logs/get-filter", { params });
    const data = unwrapRockResponse(resp);
    return normalizePaginate(data);
  }
};
